export class SidebarItem {
    constructor(title, path, icon) {
        this.title = title;
        this.path = path;
        this.icon = icon;
    }
}